import React, { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { parseCantidad } from '@/lib/recuentos';
import { sameUnit } from '@/lib/justoSearch';
import { IngredientePicker } from './IngredientePicker';

export const EquivalenciaRow = ({ r, v, catalogo, dirty, onEdit, onSave, saving }) => {
  const factorRef = useRef(null);
  const ing = catalogo.find((i) => i.id_justo === v.id_justo);
  const pick = (sel) => {
    const factor = !v.factor && sameUnit(r.unidad_tupu, sel.unidad) ? '1' : v.factor;
    onEdit({ ...v, id_justo: sel.id_justo, factor });
  };
  const rojo = r.sin_equivalencia && !dirty;
  return (
    <tr className={`border-t ${dirty ? 'bg-amber-50' : rojo ? 'bg-red-50' : ''}`} data-testid={`eq-row-${r.codigo_tupu}`}>
      <td className={`px-3 py-2 font-mono text-xs ${rojo ? 'text-red-700 font-bold' : 'text-slate-500'}`}>{r.codigo_tupu}</td>
      <td className={`px-3 py-2 ${rojo ? 'text-red-700' : 'text-slate-800'}`}>{r.nombre_tupu}</td>
      <td className="px-3 py-2 text-slate-500">{r.unidad_tupu}</td>
      <td className="px-3 py-2">
        <IngredientePicker catalogo={catalogo} value={v.id_justo} disabled={v.no_exportar} onChange={pick}
          nombreTupu={r.nombre_tupu} onTab={() => factorRef.current?.focus()} testId={`eq-picker-${r.codigo_tupu}`} />
      </td>
      <td className="px-3 py-2 text-slate-500" data-testid={`eq-unidad-justo-${r.codigo_tupu}`}>{ing?.unidad || '—'}</td>
      <td className="px-3 py-2">
        <input ref={factorRef} inputMode="decimal" value={v.factor} disabled={v.no_exportar} onChange={(e) => onEdit({ ...v, factor: e.target.value })}
          onKeyDown={(e) => e.key === 'Enter' && dirty && onSave()}
          className={`h-9 w-20 rounded-md border px-2 text-right ${Number.isNaN(parseCantidad(v.factor)) ? 'border-red-400' : ''}`} data-testid={`eq-factor-${r.codigo_tupu}`} />
      </td>
      <td className="px-3 py-2 text-center">
        <input type="checkbox" checked={v.no_exportar} onChange={(e) => onEdit({ ...v, no_exportar: e.target.checked })} className="w-4 h-4 accent-orange-500" data-testid={`eq-noexp-${r.codigo_tupu}`} />
      </td>
      <td className="px-3 py-2"><Button size="sm" disabled={!dirty || saving} onClick={onSave} data-testid={`eq-save-${r.codigo_tupu}`}>Guardar</Button></td>
    </tr>
  );
};
